/*
 * Outbound affiliate click tracking.
 *
 * Fires one `affiliate_click` event when a visitor clicks a retailer link
 * marked with [data-affiliate-link]. This is an outbound CLICK, not a purchase:
 * no value or currency is sent, and no personal data.
 *
 * Event parameters: product_id, retailer, cta_location, link_domain.
 *
 * Delivery (one path per click, in this order, to avoid double counting):
 *   1. Shopify.analytics.publish('affiliate_click', params). A custom pixel in
 *      Shopify admin (Settings > Customer events) subscribes to this event and
 *      forwards it to GA4. See notes/affiliate-click-custom-pixel.js.
 *   2. Otherwise a page-level gtag('event', ...) if the page has one.
 *   3. Otherwise window.dataLayer.push(...) if present.
 * If none exist, nothing is sent.
 *
 * Consent: if Shopify's Customer Privacy API is loaded and analytics
 * processing is not allowed, nothing is sent. Pixels also apply their own
 * consent settings.
 */
(function () {
  if (window.__affiliateClickBound) return;
  window.__affiliateClickBound = true;

  var lastFired = new WeakMap();

  function analyticsAllowed() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') {
        return cp.analyticsProcessingAllowed() === true;
      }
    } catch (e) {}
    return true;
  }

  function handle(event) {
    var link = event.target && event.target.closest && event.target.closest('[data-affiliate-link]');
    if (!link) return;
    // Left click (click) or middle click (auxclick); ignore right click.
    if (event.type === 'auxclick' && event.button !== 1) return;

    // Guard against duplicate firing for the same link.
    var now = Date.now();
    var prev = lastFired.get(link) || 0;
    if (now - prev < 1000) return;
    lastFired.set(link, now);

    if (!analyticsAllowed()) return;

    var domain = '';
    try { domain = new URL(link.href, location.href).hostname; } catch (e) {}

    var params = {
      product_id: link.getAttribute('data-product-id') || '',
      retailer: link.getAttribute('data-retailer') || '',
      cta_location: link.getAttribute('data-cta-location') || '',
      link_domain: domain,
      transport_type: 'beacon'
    };

    try {
      var publish = window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish;
      if (typeof publish === 'function') {
        publish.call(window.Shopify.analytics, 'affiliate_click', {
          product_id: params.product_id,
          retailer: params.retailer,
          cta_location: params.cta_location,
          link_domain: params.link_domain
        });
      } else if (typeof window.gtag === 'function') {
        window.gtag('event', 'affiliate_click', params);
      } else if (Array.isArray(window.dataLayer)) {
        var dl = { event: 'affiliate_click' };
        for (var k in params) dl[k] = params[k];
        window.dataLayer.push(dl);
      }
    } catch (e) {}
  }

  document.addEventListener('click', handle, true);
  document.addEventListener('auxclick', handle, true);
})();
